import { ChangeDetectorRef, Component, Input, OnInit } from "@angular/core";
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { NgxSpinnerService } from "ngx-spinner";
import { throwError } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { TypeRequest } from "src/app/components/common/form-dynamic/enum";
import { TipoIdentificacion } from "src/app/components/individual-afiliate-beneficiary/model/tipo-identificacion";
import { ValidacionesFechaNacimientoService } from "src/app/components/individual-afiliate-beneficiary/services/validaciones-fecha-nacimiento.service";
import { ValidacionesService } from "src/app/components/individual-afiliate-beneficiary/services/validaciones.service";
import { MensajeDireccion } from 'src/app/core/enums/direccion-afiliado.enum';
import { DropdownLists } from "src/app/core/helpers/dropdown-lists/dropdown-lists";
import { ValidatorsCustom } from "src/app/core/helpers/validators-custom/validators-custom";
import { IParentescoConTiposIdentificacion } from "src/app/core/models/parentesco/parentesco-interface";
import { Afiliate } from "src/app/core/models/request/afiliate";
import { IUser } from "src/app/core/models/user/user";
import { WresponseData } from "src/app/core/models/worker/wresponse-data";
import { DisaffiliationService } from "src/app/core/services/disaffiliation/disaffiliation.service";
import { GlobalService } from "src/app/core/services/global/global.service";
import { LocalStorageService } from "src/app/core/services/local-storage/local-storage.service";
import { ModalVariadoService } from "src/app/core/services/modal-variado/modal-variado.service";
import { ValidateData } from "src/app/core/utils/validate-data";
import { environment } from "src/environments/environment";

@Component({
  selector: "app-formulario-informacion-beneficiario",
  templateUrl: "./formulario-informacion-beneficiario.component.html",
  styleUrls: ["./formulario-informacion-beneficiario.component.scss"],
})
export class FormularioInformacionBeneficiarioComponent implements OnInit {
  @Input() beneficiary: FormControl;
  @Input() index: number;
  @Input() showAddress: boolean = true;

  @Input() parentescos: Array<IParentescoConTiposIdentificacion>;
  @Input() form: FormGroup;
  @Input() dataJson: any;
  @Input() workerData: WresponseData;
  public tiposIdentificacion: Array<TipoIdentificacion>;
  public tipoParentescoSeleccionado: IParentescoConTiposIdentificacion;
  public idRequestType: number = TypeRequest.AfiliateBeneficiary;
  public reasonSelectedName: string;
  public genders = [];
  public urlCategoria;
  public minimaFecha = new Date();
  public maximaFecha = new Date();

  public numeroDocumentoBeneficiario: any;
  public afiliadoData: Afiliate;
  public empresaData: any;
  public userloggedin: IUser;
  public isBneficiarioValido: string = "";
  public errorAddress;
  public errAddres = false;
  public deshabilitarEdicion: boolean = false;
  public MensajeDir: string = "";
  public solicitudesEnProcesoAcreditador: Array<any>;
  public solicitudesDeAfiliadoCargadas: boolean = false;
  public coincidenciaEncontrada: boolean = false;

  constructor(
    private formBuilder: FormBuilder,
    private _changeDetector: ChangeDetectorRef,
    private _VALIDACIONES: ValidacionesService,
    private _STORAGE: LocalStorageService,
    private _globalService: GlobalService,
    private _spinner: NgxSpinnerService,
    private _validacionesFechaNacimientoSvc: ValidacionesFechaNacimientoService,
    private disaffiliationService: DisaffiliationService,
    public _ModalVariadoService: ModalVariadoService
  ) {}

  ngOnInit() {
    this.urlCategoria =
      "http://40.117.63.112/portalpersonas/assets/pdfs/PDF%20Afiliacion%20de%20Beneficiarios.pdf";
    this.tiposIdentificacion = new Array<TipoIdentificacion>();
    this.genders = DropdownLists.genders;
    !this.workerData
      ? (this.workerData = this._STORAGE.getItemJSON(
          environment.LOCAL_STORAGE.TRABAJADOR_INFORMACION
        ))
      : null;
    this.beneficiary
      .get("parentescoPerCarg")
      .valueChanges.subscribe((value: IParentescoConTiposIdentificacion) => {
        if (
          !this.beneficiary.get("parentescoPerCarg").disabled &&
          !ValidateData.emptyObject(value)
        ) {
          let beneficiarios = this.form.controls["pacs"] as FormArray;
          this.tiposIdentificacion = value.tiposIdentificacion;
          this.beneficiary.get("tipoDocumentoObjeto").enable();
          this.beneficiary.get("fechaNacimiento").setValue(undefined);
          this.beneficiary.get("tipoDocumentoObjeto").setValue("");
          this.form.get("reason").setValue(value.id);
          this.reasonSelectedName = value.name;
          this.tipoParentescoSeleccionado = value;
          this._VALIDACIONES.getParentescosValidos(
            this.beneficiary,
            beneficiarios
          );
        }
      });

    this.beneficiary
      .get("discapacidad")
      .valueChanges.subscribe((value: any) => {
        if (!this.beneficiary.get("discapacidad").disabled) {
          if (this.beneficiary.get("tipoDocumentoObjeto").value) {
            this.obtenerValidacionRangoDeEdad(
              this.beneficiary.get("tipoDocumentoObjeto").value
            );
          }
          this.beneficiary.get("rangoC").setValue(false);
          this.beneficiary.get("fechaNacimiento").updateValueAndValidity();
          this.beneficiary.get("tipoDocumentoObjeto").setValue(undefined);
          this.form.controls["pacs"] = this.formBuilder.array([
            this.beneficiary,
          ]);


        }
      });

    this.beneficiary
      .get("tipoDocumentoObjeto")
      .valueChanges.subscribe((value: TipoIdentificacion) => {
        if (
          !this.beneficiary.get("tipoDocumentoObjeto").disabled &&
          !ValidateData.emptyObject(value)
        ) {
          this.beneficiary.get("numeroDocumento").setValue("");
          this.beneficiary.get("rangoC").setValue(false);
          this.beneficiary.get("fechaNacimiento").enable();
          this.beneficiary.get("tipoDocumento").setValue(value.valor);
          this.obtenerValidacionRangoDeEdad(value);
          this.beneficiary.get("fechaNacimiento").updateValueAndValidity();
        }
      });

    this.beneficiary
      .get("fechaNacimiento")
      .valueChanges.subscribe((value: any) => {
        if (value) {
          let rangoC = this._VALIDACIONES.obteneCategoriaC(
            this.beneficiary.value,
            value
          );
          this.beneficiary.get("rangoC").setValue(rangoC);
          this._changeDetector.detectChanges();
        }
      });
        
    let direccionPrincipal = this.workerData.validacion_afiliado.afiliado.direccion.direccionPrincipal;
    if(direccionPrincipal != "CL 25 25 25"){
      //this.validarDireccion(direccionPrincipal);
    }
    else{
      this.beneficiary
      .get("direccionResidencia").setValue("");
      this._changeDetector.detectChanges();
    }
    if(!this.showAddress){
      this.MensajeDir = MensajeDireccion.DIRECCION_ACTUALIZADA;
    }
    else{
      this.MensajeDir = MensajeDireccion.DIRECCION_DESACTUALIZADA;
    }
    
    
    this.form.get("pacs").valueChanges.subscribe((value) => {
      this.form.updateValueAndValidity();
    });
  }

  /**
   * Valido la direccion del afiliado
   * Esta debe ser tipo Dane
   */
  onBlur(direccion: string) {
  
    if(!this.ValidacionDirBeneficiario(direccion)){
      this.validarDireccion(direccion);
    }
  }

  private ValidacionDirBeneficiario(text: string): Boolean {
    //RegularExpressions.CARACTER_VALIDO
      const regex = /^[a-zA-Z0-9# -]+$/; // Expresión regular que permite letras, números, "-", y "#"
      if (text && !regex.test(text)) {
        return true;
      }
      return false;
  }

  validarDireccion(direccion: string){
    if (direccion) {
      const customErrors = { messageError: MensajeDireccion.DIRECCION_ERROR };
      this._spinner.show();
      this._globalService
        .formatoDANE(direccion)
        .pipe(      
           // Establece el tiempo de espera después de que el usuario ha dejado de escribir
          map((respuesta) => {
            if (respuesta.success) {
              this.beneficiary.get('direccionResidencia')
              .setValue(respuesta.body);   
              this.errAddres = true;    
            } else {
              this.beneficiary.get('direccionResidencia').setErrors(customErrors);
              this.errAddres = false;
               this.errorAddress = MensajeDireccion.DIRECCION_ERROR;
            }
            this.deshabilitarEdicion = true;
            this._changeDetector.detectChanges();
            this._spinner.hide();
            return respuesta;
          }),
          catchError((err) => {
            if (err.error.code.code === 422) {
              this.beneficiary.get('direccionResidencia').setErrors(customErrors);
              this.errAddres = false;
              this.errorAddress = MensajeDireccion.DIRECCION_ERROR;
            }
            this.deshabilitarEdicion = false;
            this._changeDetector.detectChanges();
            this._spinner.hide();
            return throwError(err);
          })
        )
        .subscribe();
    };
  }

  convertirAMayusculas(control: FormControl) {
    const valorIngresado = control.value;
    control.setValue(valorIngresado.toUpperCase(), { emitEvent: false });
  }

  private obtenerValidacionRangoDeEdad(value: TipoIdentificacion) {
    this.beneficiary.get("fechaNacimiento").setValue(null);
    let minimaFechaYMaximaFecha: any;
    if (value) {
      minimaFechaYMaximaFecha =
        this._validacionesFechaNacimientoSvc.reglasSegunParentescoYDocumentoDeIndentificacion(
          this.workerData,
          this.beneficiary.get("parentescoPerCarg").value.id,
          this.beneficiary.get("tipoDocumentoObjeto").value.valor,
          this.beneficiary.get("discapacidad").value
        );

      this.minimaFecha = !ValidateData.emptyObject(minimaFechaYMaximaFecha)
        ? minimaFechaYMaximaFecha.fechaDesde
        : null;
      this.maximaFecha = !ValidateData.emptyObject(minimaFechaYMaximaFecha)
        ? minimaFechaYMaximaFecha.fechaHasta
        : null;
      this.beneficiary
        .get("fechaNacimiento")
        .setValidators([
          Validators.required,
          ValidatorsCustom.validarFechaMinimoYMaximo(
            this.minimaFecha,
            this.maximaFecha
          ),
        ]);
      this.beneficiary
        .get("numeroDocumento")
        .setValidators([
          Validators.required,
          Validators.minLength(value.min),
          Validators.maxLength(value.max),
          Validators.pattern(value.expresionRegular),
          ValidatorsCustom.documentoDiferenteTrabajador(() =>
            this.form.get("trabajador.NumIdTrabajador")?.value
          ),
          ValidatorsCustom.documentoDiferenteConyuge(() =>
            this.form.get("conyuge.NumIdConyuge")?.value
          ),
          ValidatorsCustom.documentoDiferenteBeneficiarios(() => this.getBeneficiariosDocs())
        ]);
    }
  }

  getBeneficiariosDocs(): string[] {
    const pacs = this.form.get('pacs');
    
    if (pacs instanceof FormArray) {
      const beneficiarios = pacs.controls
        .map((beneficiario: FormGroup) => 
          beneficiario.get('numeroDocumento')?.value
        ) || [];
  
      return beneficiarios.filter((beneficiarioDoc, idx) => idx !== this.index);
    }
    return [];
  }
  

  showCalendar(event: any) {
    document.getElementById(event.target.id).click();
  }
}
